import http from "../../../utils/http";


// schedule 목록 가져오기
export const getTaxSingoScheduledList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/tax-singo/scheduled/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// schedule 1개 가져오기
export const getTaxSingoScheduled = (scheduledIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/tax-portal/tax-singo/scheduled/${scheduledIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// taxpayer 목록 가져오기
export const getTaxSingoTaxPayerSingoList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/tax-singo/taxpayer-singo/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// taxpayer 수정
export const putTaxSingoTaxPayerSingo = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/tax-portal/tax-singo/taxpayer-singo/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// configuration 목록 가져오기
export const getConfigurationList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/tax-singo/configuration/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// configuration 생성
export const createConfiguration = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/tax-singo/configuration`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



// 세금신고 결과 조회
export const taxSingoResultsFetch = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/tax-singo/results-fetch`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 위택스 세금신고 결과 조회
export const taxSingoWetaxResultsFetch = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/tax-singo/wetax-results-fetch`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};